import { fetchPayload } from "../../../utils/reducerOperations";
import {
    FETCH_POSITIVE_OR_NEGATIVE_RESULT_START,
    FETCH_POSITIVE_OR_NEGATIVE_RESULT_SUCCESS,
    FETCH_POSITIVE_OR_NEGATIVE_RESULT_FAILED
} from "../../constants";
import {
    fetchPositiveAndNegativeCardsDataFailed,
    fetchPositiveAndNegativeCardsDataStarted,
    fetchPositiveAndNegativeCardsDataSuccess,

} from "./Helpers";
import { Default } from "./initialState";

const StoryboardChildCardsBasedOnParentReducer = (state = Default(), action) => {
    // let payload = fetchPayload(action);
    switch (action.type) {
        case FETCH_POSITIVE_OR_NEGATIVE_RESULT_START:
            return fetchPositiveAndNegativeCardsDataStarted(state, action);
        case FETCH_POSITIVE_OR_NEGATIVE_RESULT_SUCCESS:
            return fetchPositiveAndNegativeCardsDataSuccess(state, action);
        case FETCH_POSITIVE_OR_NEGATIVE_RESULT_FAILED:
            return fetchPositiveAndNegativeCardsDataFailed(state, action);
        default:
            return { ...state };
    }
};

export default StoryboardChildCardsBasedOnParentReducer;
